import React from "react";
import { motion } from "framer-motion";
import { Mail, MapPin, MessageCircle, ArrowUpRight, Sparkles } from "lucide-react";

export default function Contact() {
  return (
    <section id="contact" className="relative py-32 overflow-hidden">
      <div className="aurora bg-[#C9A227] w-[520px] h-[520px] -top-40 -left-40" style={{opacity:0.18}} />
      <div className="aurora bg-[#047857] w-[520px] h-[520px] bottom-0 -right-40" style={{opacity:0.16}} />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto">
          <span className="eyebrow-emerald">Let's Build Together</span>
          <h2 className="mt-6 text-4xl md:text-6xl font-semibold leading-tight">
            Transform ideas into <span className="text-gold-gradient">industry-leading brands.</span>
          </h2>
          <p className="mt-6 text-white/60 text-lg">
            Whether you're launching a startup, scaling an established business or building an enterprise solution — we're ready when you are.
          </p>
        </div>

        <div className="mt-16 grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5 space-y-4">
            {[
              { icon: Mail, label: "Email Us", value: "business@syr.co.in", href: "mailto:business@syr.co.in" },
              { icon: MessageCircle, label: "WhatsApp", value: "Chat with our team", href: "https://wa.me/917610512615" },
              { icon: MapPin, label: "Corporate Office", value: "C-116, Ground Floor, Sector 2, Noida, UP – 201301" },
            ].map((c) => (
              <a
                key={c.label}
                href={c.href || "#"}
                target={c.href && c.href.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer"
                className="card-lift glass rounded-2xl p-5 flex items-center gap-4 group"
              >
                <div className="w-11 h-11 rounded-xl grid place-items-center bg-[#C9A227]/10 border border-[#C9A227]/30">
                  <c.icon size={18} className="text-[#F4D983]" />
                </div>
                <div className="flex-1">
                  <div className="text-[11px] uppercase tracking-[0.28em] text-white/40">{c.label}</div>
                  <div className="text-white/85 mt-1">{c.value}</div>
                </div>
                {c.href && (
                  <ArrowUpRight size={18} className="text-white/40 group-hover:text-[#F4D983] group-hover:-translate-y-1 group-hover:translate-x-1 transition-transform" />
                )}
              </a>
            ))}
          </div>

          <motion.div
            initial={{opacity:0, y:20}}
            whileInView={{opacity:1, y:0}}
            viewport={{once:true}}
            transition={{duration:0.7, ease:[0.16,1,0.3,1]}}
            className="lg:col-span-7 relative rounded-3xl p-8 md:p-12 glass overflow-hidden flex flex-col justify-center"
          >
            <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-[#047857]/20 blur-3xl" />
            <div className="absolute -bottom-24 -left-24 w-64 h-64 rounded-full bg-[#C9A227]/15 blur-3xl" />
            <div className="relative">
              <span className="eyebrow"><Sparkles size={12} /> Ready When You Are</span>
              <h3 className="mt-6 text-3xl md:text-4xl font-semibold leading-tight">
                Start your <span className="text-gold-gradient">growth story</span> today.
              </h3>
              <p className="mt-4 text-white/60 leading-relaxed max-w-lg">
                Reach out over WhatsApp or email and our team will get back to you within 24 hours with a tailored growth plan for your business.
              </p>

              <div className="mt-10 flex flex-wrap items-center gap-4">
                <a href="https://wa.me/917610512615" target="_blank" rel="noreferrer" className="btn-gold">
                  <MessageCircle size={18} /> Chat on WhatsApp
                </a>
                <a href="mailto:business@syr.co.in" className="btn-ghost">
                  <Mail size={18} /> Email Us
                </a>
              </div>

              <div className="mt-10 flex flex-wrap gap-2 text-xs text-white/50">
                {["AI Powered","ROI Focused","Global Solutions","24×7 Support"].map(t=>(
                  <span key={t} className="px-3 py-1.5 rounded-full border border-white/10 bg-white/[0.02]">✓ {t}</span>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
